import { defineStore } from 'pinia';
import type { Ref } from 'vue';
import { ref } from 'vue';
import { RouteLocationNormalizedLoaded } from 'vue-router';

export interface AbortControllerStore {
  addAbortController: (
    abortController: AbortController,
    route: RouteLocationNormalizedLoaded,
  ) => void;
  cancelRequests: (
    route: RouteLocationNormalizedLoaded,
    reason?: string,
  ) => void;
}

type Payload = {
  abortController: AbortController;
  route: RouteLocationNormalizedLoaded;
};

const _useAbortControllerStore = defineStore(
  'abortController',
  (): AbortControllerStore => {
    const abortControllers: Ref<Payload[]> = ref([]);

    const addAbortController = (
      abortController: AbortController,
      route: RouteLocationNormalizedLoaded,
    ) => {
      abortControllers.value.push({ abortController, route });
    };

    const cancelRequests = (
      route: RouteLocationNormalizedLoaded,
      reason?: string,
    ) => {
      abortControllers.value
        .filter((payload) => payload.route === route)
        .forEach((payload) => payload.abortController.abort(reason));

      // Clear only payloads for the given route
      abortControllers.value = abortControllers.value.filter(
        (payload) => payload.route !== route,
      );
    };

    return {
      addAbortController,
      cancelRequests,
    };
  },
);

export const useAbortControllerStore = (): AbortControllerStore => {
  const store = _useAbortControllerStore();
  const { addAbortController, cancelRequests } = store;

  return {
    addAbortController,
    cancelRequests,
  };
};
